import { z } from 'zod';


// Validación del formulario "Nuevo: Corte" (pestañas General + Agrupación, submit único).
// Los mensajes son claves i18n; los componentes llaman translate() al renderizar.
const createMonthlyCutBaseSchema = z.object({
  // Empresa: requerida SIEMPRE (también en modo holding), porque el backend la exige como
  // empresa desde la que se solicita el corte. Al activar "aplicar a todas" se deshabilita
  // el selector pero el valor se conserva.
  targetCompanyId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  applyToAllCompanies: z.boolean(),
  year: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  month: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  startDate: z.string().min(1, 'attendance:monthlyCutCreate.validation.startDateRequired'),
  endDate: z.string().min(1, 'attendance:monthlyCutCreate.validation.endDateRequired'),
  // Agrupación: al menos una agrupación asignada (AC ASIS-4966).
  groupIds: z.array(z.number()).min(1, 'attendance:monthlyCutCreate.validation.groupsRequired'),
});

export const createMonthlyCutSchema = createMonthlyCutBaseSchema
  // La empresa solo es obligatoria en corte puntual. En modo holding ("aplicar a todas")
  // el selector se deshabilita y el front envía la empresa del usuario logueado.
  .refine((data) => data.applyToAllCompanies || data.targetCompanyId !== null, {
    message: 'attendance:monthlyCutCreate.validation.companyRequired',
    path: ['targetCompanyId'],
  })
  .refine((data) => data.year !== null, {
    message: 'attendance:monthlyCutCreate.validation.yearRequired',
    path: ['year'],
  })
  .refine((data) => data.month !== null, {
    message: 'attendance:monthlyCutCreate.validation.monthRequired',
    path: ['month'],
  })
  .refine(
    (data) => !data.startDate || !data.endDate || data.startDate <= data.endDate,
    {
      message: 'attendance:monthlyCutCreate.validation.dateRangeInvalid',
      path: ['endDate'],
    },
  );

export type CreateMonthlyCutFormData = z.infer<typeof createMonthlyCutSchema>;
